import { Link } from 'react-router-dom';
import MetricState from './MetricState';
import TrendBadge from './TrendBadge';
import Sparkline from './Sparkline';

/**
 * Reusable KPI card shell. All KPI cards share this structure:
 *   [icon tile] title ........ link
 *   BIG VALUE   trend badge   sparkline
 *   footnote
 * State handling (loading/empty/error) is delegated to MetricState.
 */
export default function KpiCard({
  testId, title, icon, tone = 'primary', to, linkLabel,
  status, error, onRetry, emptyText,
  value, delta, lowerIsBetter, sparkline, footnote, ariaValueText,
}) {
  const sparkColor = { primary: '#007BFF', success: '#28A745', warning: '#FFC107', danger: '#DC3545', info: '#00D4FF' }[tone];
  return (
    <section className="cb-card cb-kpi h-100 min-w-0" data-testid={testId} aria-label={title}>
      <header className="d-flex align-items-center gap-2 mb-2">
        <span className={`cb-icon-tile cb-icon-tile--${tone}`} aria-hidden="true"><i className={`bi ${icon}`} /></span>
        <h3 className="cb-kpi__title mb-0">{title}</h3>
        {to && (
          <Link to={to} className="ms-auto small text-decoration-none" aria-label={linkLabel || `View ${title} details`}>
            <i className="bi bi-arrow-right-short fs-5" aria-hidden="true" />
          </Link>
        )}
      </header>
      <MetricState status={status} error={error} onRetry={onRetry} emptyText={emptyText}>
        <div className="cb-kpi__value" aria-label={ariaValueText}>{value}</div>
        <TrendBadge delta={delta} lowerIsBetter={lowerIsBetter} />
        {sparkline && <div className="mt-2"><Sparkline values={sparkline} color={sparkColor} /></div>}
        {footnote && <div className="cb-kpi__foot small text-muted mt-2">{footnote}</div>}
      </MetricState>
    </section>
  );
}
